'use client';

import { c as _c } from "react/compiler-runtime";
import { CHANGE_MENTORING_SUBSCRIPTION_OUTCOME, type ChangeMentoringSubscriptionOutputDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/change-mentoring-subscription/output.dto';
import { formatWarsawLongDate } from '@algoacademy/shared/warsaw-calendar';
import { formatGrosze, formatTermsSummary } from '../_helpers/mentoring-terms';
type ChangeOutcomeSummaryProps = {
  outcome: ChangeMentoringSubscriptionOutputDTO;
};

/**
 * What the submission actually did. Three different things can happen and two of
 * them look like nothing happened, so each is said out loud instead of leaving
 * staff to guess from a green toast.
 */
export function ChangeOutcomeSummary(t0) {
  const $ = _c(40);
  const {
    outcome
  } = t0;
  const {
    scheduledChange
  } = outcome;
  if (outcome.outcome === CHANGE_MENTORING_SUBSCRIPTION_OUTCOME.SCHEDULED && scheduledChange !== null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="font-medium text-contentGreen text-sm">Zmiana zapisana</p>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== scheduledChange.effectiveAt) {
      t2 = formatWarsawLongDate(scheduledChange.effectiveAt);
      $[1] = scheduledChange.effectiveAt;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== scheduledChange.billingCadenceLabel || $[4] !== scheduledChange.hoursWithMentor || $[5] !== scheduledChange.mentoringTypeLabel) {
      t3 = formatTermsSummary({
        mentoringTypeLabel: scheduledChange.mentoringTypeLabel,
        billingCadenceLabel: scheduledChange.billingCadenceLabel,
        hoursWithMentor: scheduledChange.hoursWithMentor
      });
      $[3] = scheduledChange.billingCadenceLabel;
      $[4] = scheduledChange.hoursWithMentor;
      $[5] = scheduledChange.mentoringTypeLabel;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== scheduledChange.priceGrosze) {
      t4 = formatGrosze(scheduledChange.priceGrosze);
      $[7] = scheduledChange.priceGrosze;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
      t5 = <div role="status" className="flex flex-col gap-1 rounded-lg border border-borderSuccess bg-backgroundSecondary p-4">{t1}<p className="text-contentSecondary text-sm">Od {t2} mentoring to:{" "}{t3}. Odnowienie zostanie rozliczone na {t4} - w cenie 23% VAT. Do tej daty uczeń ma dotychczasowe warunki.</p></div>;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  if (outcome.outcome === CHANGE_MENTORING_SUBSCRIPTION_OUTCOME.TAKEN_BACK) {
    let t1;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="font-medium text-contentPrimary text-sm">Zaplanowana zmiana wycofana</p>;
      $[13] = t1;
    } else {
      t1 = $[13];
    }
    let t2;
    if ($[14] !== outcome.renewsAt) {
      t2 = formatWarsawLongDate(outcome.renewsAt);
      $[14] = outcome.renewsAt;
      $[15] = t2;
    } else {
      t2 = $[15];
    }
    let t3;
    if ($[16] !== outcome.current.billingCadenceLabel || $[17] !== outcome.current.hoursWithMentor || $[18] !== outcome.current.mentoringTypeLabel) {
      t3 = formatTermsSummary({
        mentoringTypeLabel: outcome.current.mentoringTypeLabel,
        billingCadenceLabel: outcome.current.billingCadenceLabel,
        hoursWithMentor: outcome.current.hoursWithMentor
      });
      $[16] = outcome.current.billingCadenceLabel;
      $[17] = outcome.current.hoursWithMentor;
      $[18] = outcome.current.mentoringTypeLabel;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    let t4;
    if ($[20] !== t2 || $[21] !== t3) {
      t4 = <div role="status" className="flex flex-col gap-1 rounded-lg border border-borderPrimary bg-backgroundSecondary p-4">{t1}<p className="text-contentSecondary text-sm">Nic już nie czeka na odnowienie {t2}. Uczeń zostaje na:{" "}{t3}.</p></div>;
      $[20] = t2;
      $[21] = t3;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    return t4;
  }
  if (scheduledChange !== null) {
    let t1;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="font-medium text-contentPrimary text-sm">Nic nie zmieniono</p>;
      $[23] = t1;
    } else {
      t1 = $[23];
    }
    let t2;
    if ($[24] !== scheduledChange.effectiveAt) {
      t2 = formatWarsawLongDate(scheduledChange.effectiveAt);
      $[24] = scheduledChange.effectiveAt;
      $[25] = t2;
    } else {
      t2 = $[25];
    }
    let t3;
    if ($[26] !== scheduledChange.billingCadenceLabel || $[27] !== scheduledChange.hoursWithMentor || $[28] !== scheduledChange.mentoringTypeLabel) {
      t3 = formatTermsSummary({
        mentoringTypeLabel: scheduledChange.mentoringTypeLabel,
        billingCadenceLabel: scheduledChange.billingCadenceLabel,
        hoursWithMentor: scheduledChange.hoursWithMentor
      });
      $[26] = scheduledChange.billingCadenceLabel;
      $[27] = scheduledChange.hoursWithMentor;
      $[28] = scheduledChange.mentoringTypeLabel;
      $[29] = t3;
    } else {
      t3 = $[29];
    }
    let t4;
    if ($[30] !== t2 || $[31] !== t3) {
      t4 = <div role="status" className="flex flex-col gap-1 rounded-lg border border-borderPrimary bg-backgroundSecondary p-4">{t1}<p className="text-contentSecondary text-sm">Te warunki są już zaplanowane od {t2}:{" "}{t3}. Nie utworzyliśmy nowej zmiany ani eventu CRM.</p></div>;
      $[30] = t2;
      $[31] = t3;
      $[32] = t4;
    } else {
      t4 = $[32];
    }
    return t4;
  }
  let t1;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="font-medium text-contentPrimary text-sm">Nic nie zmieniono</p>;
    $[33] = t1;
  } else {
    t1 = $[33];
  }
  let t2;
  if ($[34] !== outcome.current.billingCadenceLabel || $[35] !== outcome.current.hoursWithMentor || $[36] !== outcome.current.mentoringTypeLabel) {
    t2 = formatTermsSummary({
      mentoringTypeLabel: outcome.current.mentoringTypeLabel,
      billingCadenceLabel: outcome.current.billingCadenceLabel,
      hoursWithMentor: outcome.current.hoursWithMentor
    });
    $[34] = outcome.current.billingCadenceLabel;
    $[35] = outcome.current.hoursWithMentor;
    $[36] = outcome.current.mentoringTypeLabel;
    $[37] = t2;
  } else {
    t2 = $[37];
  }
  let t3;
  if ($[38] !== t2) {
    t3 = <div role="status" className="flex flex-col gap-1 rounded-lg border border-borderPrimary bg-backgroundSecondary p-4">{t1}<p className="text-contentSecondary text-sm">Te warunki już obowiązują:{" "}{t2}. Nie zaplanowaliśmy żadnej zmiany.</p></div>;
    $[38] = t2;
    $[39] = t3;
  } else {
    t3 = $[39];
  }
  return t3;
}